module.exports = __webpack_public_path__ + "static/img/thank-you-ballon.47d38d0.svg";